import { Field } from "./Field";

/** Outline search glyph, same icon vocabulary (round caps/joins, no fill, `aria-hidden`) as every other v3 icon. */
function SearchIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      aria-hidden="true"
      className="v2-search-field__icon"
    >
      <path d="M11 18a7 7 0 1 0 0-14a7 7 0 0 0 0 14zM20 20l-4-4" />
    </svg>
  );
}

/**
 * Toolbar search box shared by Campañas and Plantillas (panel-feedback round 3):
 * same look as the Contactos search (border #cbd5e1, radius 6, 40px, 16px icon),
 * no visible label (kept accessible), no submit button (callers debounce).
 */
export function SearchField({
  id,
  label,
  value,
  onChange,
  maxLength,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}) {
  return (
    <div className="v2-search-field">
      <Field label={label} htmlFor={id} hideLabel>
        <span className="v2-search-field__box">
          <SearchIcon />
          <input
            id={id}
            type="search"
            value={value}
            maxLength={maxLength}
            onChange={(event) => onChange(event.target.value)}
            placeholder={label}
          />
        </span>
      </Field>
    </div>
  );
}
